import Swal from "sweetalert2";
import Vue from "vue";
import { utils } from "./utils";
import { responses } from "./responses";
import { errorHandler } from "./errorHandler";
import { hapticFeedback } from "./HapticFeedback";
import { colorIndicator } from "./ColorIndicator";
import { rippleEffect } from "./RippleEffect";
import { popover } from "./Popover";
import queryStringify from "qs-stringify";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { Capacitor } from "@capacitor/core";
import { openPdfNative, openExcelNative, openFileNativeByMime } from "./nativeOpeners";

Vue.use(VueGoodTablePlugin);
window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`;
// window.franchiseApi = `http://127.0.0.1:8015/api/`

// === AB#5178: lytningtomcat base URLs are build-time env-driven ===
// Every lytningtomcat URL below resolves via process.env.VUE_APP_API_* at build
// time. .env.production sets Live values; .env.staging sets Test_* where a Test_*
// twin exists. The trailing-string fallback is the Live URL — the bundle always
// renders to Live if the env var is missing (matches the production safety
// default). See docs/design-docs/2026-08-05-env-driven-api-urls.md.
// Other domains (chrilantech.com, lna.pos.co.zm) stay hardcoded — out of scope.
// Live env: ReportsApi/
// Staging env: Test_ReportsApi/
window.reportsApi = (process.env.VUE_APP_API_REPORTS || `https://lytningtomcat.chrilantech.com/ReportsApi/`) + `api/v2/`;

// Live env: AnalyticsDocuments/api/v1/. Staging env: Test_AnalyticsDocuments/api/v1/
// (Test_ twin live on lytningtomcat since 2026-10-12, ticket 29094).
window.docsApi = process.env.VUE_APP_API_DOCS || `https://lytningtomcat.chrilantech.com/AnalyticsDocuments/api/v1/`;
// window.docsApi = `http://192.168.0.188:8282/AnalyticsDocuments/api/v1/`;

// Ticket 29094: AnalyticsDocuments CONTEXT-ROOT base (no /api/v1 suffix) — for
// endpoints mounted at the context root (e.g. /api/excel/exportFranchiseInvoices).
// Same env-driven pattern as docsApi above (see AB#5178 design doc):
//   .env.production sets the Live context  → AnalyticsDocuments
//   .env.staging    sets the Test_ context → Test_AnalyticsDocuments
// The trailing-string fallback is the Live context — the bundle always renders
// to Live if the env var is missing (production safety default).
window.docsApiBase = process.env.VUE_APP_API_DOCS_BASE || `https://lytningtomcat.chrilantech.com/AnalyticsDocuments`;

window.regApi = `https://chrilantech.com/regmac/api/`;
// window.franchiseApi = `http://127.0.0.1:8000/api/`

// Live env: OnlineSalesServer (no Test_* twin used by Analytics; stays Live)
window.serverApi = process.env.VUE_APP_API_SERVER || `https://lytningtomcat.chrilantech.com/OnlineSalesServer/`;
// window.serverApi = `http://10.0.0.111:8282/OnlineSalesServer/`
window.onlineSalesTomcatApi = serverApi;

window.gateWayApi = `https://lna.pos.co.zm/KazangPaymentGateway/GateWay/`;
// window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`

// Live env: FranchiseSpringServer (no Test_* twin on this host)
window.stocklistApi = process.env.VUE_APP_API_FRANCHISE_SPRING || `https://lytningtomcat.chrilantech.com/FranchiseSpringServer/`;
// window.stocklistApi ='http://192.168.0.188:8282/FranchiseSpringServer/'

// Live env: Franchise_OnlineServer (no Test_* twin used by Analytics; stays Live)
window.franchiseTomcatApi = process.env.VUE_APP_API_FRANCHISE || `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/`;
// window.franchiseTomcatApi = ` http://localhost:8080/Franchise_OnlineServer/`

window.StockTemplateApi = `https://chrilantech.com/LytSoftPosOnline/api/`;
// window.StockTemplateApi = `http://127.0.0.1:8015/api/`

// Base APIs for Quick Printable PDFs
// PDF reports base (hosted on chrilantech.com)
window.pdfReportApi = `${window.franchiseApi}PDFReport/`;
// Print API for waiter/tips reports (hosted on lytningtomcat.chrilantech.com)
window.salesReportsPrintApi = window.salesReportsPrintApi || `${window.printApi}sales_reports/`;

// Live env: Lyt-SoftBackOfficeApi (no Test_* twin used by Analytics; stays Live)
window.backOfficeTomcatApi = process.env.VUE_APP_API_BACKOFFICE || `https://lytningtomcat.chrilantech.com/Lyt-SoftBackOfficeApi/`;
// window.backOfficeTomcatApi = `http://localhost:9090/Lyt-SoftBackOfficeApi/`

// Live env: SubscriptionManager/api (no Test_* twin on this host)
window.subscriptionTomcatApi = process.env.VUE_APP_API_SUBSCRIPTION || `https://lytningtomcat.chrilantech.com/SubscriptionManager/api/`;
// window.subscriptionTomcatApi = `http://localhost:8080/subscription/api/`
window.customerPanelApi = subscriptionTomcatApi + `adminCustomerPanel/`;

// Live env: PrintApi (no Test_PrintApi — Retail POS rule applies to the whole stack)
window.printApi = process.env.VUE_APP_API_PRINT || `https://lytningtomcat.chrilantech.com/PrintApi/`;
// window.printApi = `http://desktop-js3p555:7087/PrintApi/`

window.responses = responses;
window.errorHandler = errorHandler;

window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
  let uuid = "",
    i,
    random;
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += "-";
    }
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
};

Vue.prototype.$utils = utils;
window.$utils = utils;

// Register haptic feedback and color indicator services globally
Vue.prototype.$hapticFeedback = hapticFeedback;
window.$hapticFeedback = hapticFeedback;

Vue.prototype.$colorIndicator = colorIndicator;
window.$colorIndicator = colorIndicator;

// Register ripple effect service globally
Vue.prototype.$rippleEffect = rippleEffect;
window.$rippleEffect = rippleEffect;

// Register popover service globally
Vue.prototype.$popover = popover;
window.$popover = popover;

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1500,
  showCloseButton: true,
  customClass: "toastr",
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);
window.openUrl = (url, target = "_blank") => window.open(url, target, "_blank");
window.getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
window.pageOptions = {
  enabled: true,
  mode: "pages",
  perPage: 10,
  position: "bottom",
  perPageDropdown: [10, 100, 200],
  dropdownAllowAll: false,
  jumpFirstOrLast: true,
  pageLabel: "page", // for 'pages' mode
};

/**
 * Build a readable, unique export filename without extension.
 * Pattern: "<Base> - <Store> - <From>_to_<To> - <YYYYMMDD-HHmmss>"
 * All parts are sanitized for filesystem safety; length capped to ~180 chars.
 * @param {string} base
 * @param {{storeLabel?:string, from?:string, to?:string}} ctx
 * @returns {string}
 */
window.buildExportName = (base, ctx = {}) => {
  try {
    const pad = (n) => String(n).padStart(2, '0');
    const now = new Date();
    const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    const safe = (s) => (s || '').toString().replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim();
    const store = safe(ctx.storeLabel || 'All Stores');
    const from = safe(ctx.from || '');
    const to = safe(ctx.to || '');
    const range = (from && to) ? `${from}_to_${to}` : stamp;
    const name = `${safe(base || 'Table Export')} - ${store} - ${range} - ${stamp}`;
    return name.slice(0, 180);
  } catch (e) {
    const d = new Date();
    return `export_${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getDate()).padStart(2,'0')}-${String(d.getHours()).padStart(2,'0')}${String(d.getMinutes()).padStart(2,'0')}${String(d.getSeconds()).padStart(2,'0')}`;
  }
};

window.isValidString = (string) => {
  if (!string) return false;
  string = string.toString().trim();
  return !(string === `null` || string === `undefined` || string === ``);
};

import store from "../store";

window.openFile = (response, fileName) => {
  // Ensure loader is shown while preparing and triggering the download/open
  try {
    if (store && store.commit) store.commit('setLoadingState', true);

    const explicitType = (response && response.headers && response.headers["content-type"]) || "application/octet-stream";
    let type = getFileType(response) || { mime: explicitType };
    const data = response && response.data;
    const blob = new Blob([data], { type: type.mime });

    // Build a safe filename + extension with filename-based fallback
    let mime = type.mime || explicitType;
    let ext = 'bin';
    if (mime.includes('pdf')) ext = 'pdf';
    else if (mime.includes('spreadsheetml.sheet')) ext = 'xlsx';
    else if (mime.includes('vnd.ms-excel')) ext = 'xls';
    else if (mime.includes('csv')) ext = 'csv';

    const lowerName = (fileName || '').toLowerCase();
    if (ext === 'bin') {
      if (lowerName.endsWith('.xlsx')) { mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; ext = 'xlsx'; }
      else if (lowerName.endsWith('.xls')) { mime = 'application/vnd.ms-excel'; ext = 'xls'; }
      else if (lowerName.endsWith('.pdf')) { mime = 'application/pdf'; ext = 'pdf'; }
      else if (lowerName.endsWith('.csv')) { mime = 'text/csv'; ext = 'csv'; }
    }

    const finalName = lowerName && (lowerName.endsWith('.pdf') || lowerName.endsWith('.xlsx') || lowerName.endsWith('.xls') || lowerName.endsWith('.csv'))
      ? fileName
      : `${fileName}.${ext}`;

    // Android: open natively via Capacitor Filesystem + FileOpener
    const platform = (typeof Capacitor !== 'undefined' && Capacitor.getPlatform) ? Capacitor.getPlatform() : 'web';
    if (platform === 'android') {
      if (mime.includes('pdf')) return openPdfNative(blob, finalName);
      if (mime.includes('spreadsheetml.sheet') || mime.includes('vnd.ms-excel')) return openExcelNative(blob, finalName);
      return openFileNativeByMime(blob, mime, finalName);
    }

    // Web/Electron: fall back to classic download
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", finalName);
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the Blob URL after a short delay
    try { link.parentNode && link.parentNode.removeChild(link); } catch (e) { /* ignore */ }
    setTimeout(() => {
      try { window.URL.revokeObjectURL(downloadUrl); } catch (e) { /* ignore */ }
    }, 30000);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to open file', err);
    try { errorHandler.tomcatError && errorHandler.tomcatError(err); } catch(e) { /* ignore */ }
  } finally {
    // Slight delay to avoid flicker for very fast operations
    setTimeout(() => { try { if (store && store.commit) store.commit('setLoadingState', false); } catch(e){} }, 300);
  }
};
window.fileTypes = [
  { mime: `text/csv`, extension: `csv` },
  { mime: `application/pdf`, extension: `pdf` },
  { mime: `application/vnd.ms-excel`, extension: `xls` },
  { mime: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, extension: `xlsx` },
];
window.getFileType = (response) => {
  return fileTypes.find((ty) => ty.mime === response.headers["content-type"]);
};

// ApiServer for VAT reports
window.ApiServer = "https://chrilantech.com/LytSoftPosOnline/api/";
// window.ApiServer = "http://127.0.0.1:8015/api/";

// Synergy API - used by App Usage tracking
window.synergyApi = `https://lna.pos.co.zm/SynergyApi/api/v1/`
// window.synergyApi = `http://localhost:8282/SynergyApi/api/v1/`

